// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"233c92b8","453":"ee671459","455":"26e8124b","977":"dffe72fe"}[chunkId] + ".chunk.js";
};